import React from 'react';
import Utils from 'context/utils';

/**
 * How long an execution ran, in milliseconds, or null if that is not a question with an answer yet.
 *
 * Measured from `started_at` rather than `created_at`, so it means execution time and not the wait
 * in front of it — the same thing "Duration" means on the per-processor event rows. A run that has
 * started but not ended reports how long it has been going, which is the number worth seeing at a
 * glance; it is true at the moment it is read and changes on the next refresh, so the column renders
 * it muted rather than as a settled fact.
 *
 * `nowMs` is a parameter rather than a call to `Date.now()` inside, so the elapsed case is testable
 * without a clock.
 */
export function executionDurationMs(execution, nowMs = Date.now()) {
  if (!execution) return null;
  const started = Utils.toEpochMs(execution.started_at);
  if (started === null) return null;
  const ended = Utils.toEpochMs(execution.ended_at);
  return (ended === null ? nowMs : ended) - started;
}

/**
 * The column's VALUE is the number, not the formatted string, for two reasons: sorting then orders
 * by time instead of alphabetically ("2m 14s" before "5.00s"), and AG Grid repaints a cell when its
 * value changes, so a running execution's cell updates as the elapsed time grows.
 */
export function durationValueGetter(params) {
  return executionDurationMs(params.data, Date.now());
}

export function durationCellRenderer(params) {
  const text = Utils.formatDuration(params.value);
  // No start means no duration — an em dash, because a zero would claim the run took no time.
  if (text === null) return (<span className="text-muted">&mdash;</span>);
  const ended = params.data && params.data.ended_at;
  return ended ? (<>{text}</>) : (<span className="text-muted">{text}</span>);
}
